import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { InventoryLabelContainerModel } from '../../../../../../models/aggregates/erp/label';
import { Core2Config } from '../../shared/core2Config';

@Injectable({
  providedIn: 'root'
})
export class InventoryLabelService extends BaseApiTemplateService<InventoryLabelContainerModel> {

  readonly url = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'inventory-labels';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'inventory-labels';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'inventory-labels';
    this.httpClient = http;
  }

}
